// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__2R4gZ","contentMobile":"header_contentMobile__p9j4c","placeholder":"header_placeholder__3M0Ix","row":"header_row__3Zh9j","contentDesktop":"header_contentDesktop__1Wtq5"};
    if(module.hot) {
      // 1745935652210
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  